// @noflow
import './styles.css';

import { decreaseZoomMap, increaseZoomMap, mergeThresholdMap, responsiveVars } from './constants';
import { injectIntl, intlShape } from 'react-intl';
import React, { Component } from 'react';

import DOMResize from '~/components/dom/dom-resize';
import Logs from './logs';
import { momentObj } from 'react-moment-proptypes';
import PropTypes from 'prop-types';
import Timeline from './timeline';
import ZoomControls from './zoom';
// import PreventBackGesture from '../prevent-back-gesture';

const {
    MAX_TICKS_MOBILE,
    MAX_TICKS_TABLET,
    MAX_TICKS_DESKTOP,
    MAX_TICKS_LARGE,
    MAX_TICKS_XLARGE,
    MIN_TICKS_ON_SCREEN,
    MERGE_THRESHOLD_HOUR,
    VIEW_MOBILE,
    VIEW_TABLET,
    VIEW_DESKTOP,
    VIEW_LARGE,
    ZOOM_HOUR,
    ZOOM_MINS
} = responsiveVars;

const getTicksToDisplay = componentWidth => {
    const truthMap = {
        [true]: MIN_TICKS_ON_SCREEN,
        [componentWidth > VIEW_LARGE]: MAX_TICKS_XLARGE,
        [componentWidth > VIEW_DESKTOP && componentWidth <= VIEW_LARGE]: MAX_TICKS_LARGE,
        [componentWidth > VIEW_TABLET && componentWidth <= VIEW_DESKTOP]: MAX_TICKS_DESKTOP,
        [componentWidth > VIEW_MOBILE && componentWidth <= VIEW_TABLET]: MAX_TICKS_TABLET,
        [componentWidth <= VIEW_MOBILE]: MAX_TICKS_MOBILE
    };

    return truthMap[true];
};

const canIncrease = zoomLevel => zoomLevel !== ZOOM_MINS;
const canDecrease = zoomLevel => zoomLevel !== ZOOM_HOUR;

class LogsTimeline extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        now: momentObj.isRequired,
        sensorLogs: PropTypes.array.isRequired,
        simpleMergedLabel: PropTypes.bool,
        timelineEnd: PropTypes.number.isRequired,
        timelineStart: PropTypes.number.isRequired,
        updateZoomLevel: PropTypes.func.isRequired,
        zoomLevel: PropTypes.number
    };

    static defaultProps = {
        zoomLevel: ZOOM_HOUR
    };

    increaseZoom = () => {
        const { zoomLevel, updateZoomLevel } = this.props;
        if (!canIncrease(zoomLevel)) {
            return;
        }
        const nextZoomLevel = increaseZoomMap[zoomLevel];
        updateZoomLevel(nextZoomLevel);
    };

    decreaseZoom = () => {
        const { zoomLevel, updateZoomLevel } = this.props;
        if (!canDecrease(zoomLevel)) {
            return;
        }
        const nextZoomLevel = decreaseZoomMap[zoomLevel];
        updateZoomLevel(nextZoomLevel);
    };

    render() {
        const {
            intl: { formatMessage },
            now,
            simpleMergedLabel,
            sensorLogs,
            timelineEnd,
            timelineStart,
            zoomLevel
        } = this.props;

        return (
            <DOMResize>
                {({ width }) => (
                    <div>
                        <ZoomControls
                            canDecrease={canDecrease(zoomLevel)}
                            canIncrease={canIncrease(zoomLevel)}
                            decreaseZoom={this.decreaseZoom}
                            increaseZoom={this.increaseZoom}
                            zoomLevel={zoomLevel}
                        />
                        {/* <PreventBackGesture className="logs-timeline-container"> */}
                        <div className="logs-timeline-container">
                            <div className="logs-timeline-component">
                                <Timeline
                                    minTicksDisplayed={getTicksToDisplay(width)}
                                    now={now}
                                    timelineEnd={timelineEnd}
                                    timelineStart={timelineStart}
                                    zoomLevel={zoomLevel}
                                />
                                <Logs
                                    formatMessage={formatMessage}
                                    mergeThreshold={mergeThresholdMap[zoomLevel] || MERGE_THRESHOLD_HOUR}
                                    minTicksDisplayed={getTicksToDisplay(width)}
                                    sensorLogs={sensorLogs}
                                    simpleMergedLabel={simpleMergedLabel}
                                    timelineEnd={timelineEnd}
                                    timelineStart={timelineStart}
                                    zoomLevel={zoomLevel}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </DOMResize>
        );
    }
}

export default injectIntl(LogsTimeline);



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/index.js